import React from 'react';
import Notification from '~/components/Notification';
import {Button, Link, Stack} from '@customink/pigment-react';

interface UploadFileTimeoutErrorProps {
  dismiss: () => void;
}

export default function UploadFileTimeoutError(
  props: UploadFileTimeoutErrorProps
) {
  const {dismiss} = props;

  return (
    <Notification
      dismiss={dismiss}
      type="error"
      title="Upload failed. Please try again.">
      <p>
        Still having trouble? We’re here to help —{' '}
        <Link href="#/help" onClick={dismiss}>
          contact us
        </Link>{' '}
        .
      </p>
      <Stack className="notification-stack">
        <Button
          size="large"
          variant="secondary"
          className="notification-cta"
          onClick={dismiss}>
          Close
        </Button>
      </Stack>
    </Notification>
  );
}
